import { c as _c } from "react/compiler-runtime";
import { locale } from "@locale";
import classNames from "classnames";
import LabelledCheck from "src/components/labelledcheck/LabelledCheck";
import InlineSelectorWrapper from "src/components/selectorwrapper/InlineSelectorWrapper";
import { useSelectedCinemaContext } from "src/lib/contexts/ContextTypes";
import getThemeStyles from "src/lib/styling/getThemeStyles";
import styles from "./InlineCinemaFilter.module.css";

//#region [Props]
type InlineCinemaFilterProps = {
  className?: string;
  showFilter?: boolean;
};
//#endregion

//#region [Component]
export default function InlineCinemaFilter(t0) {
  const $ = _c(37);
  const {
    className,
    showFilter
  } = t0;
  const cinemaContext = useSelectedCinemaContext();
  let t1;
  if ($[0] !== cinemaContext) {
    t1 = cinemas => cinemaContext.setSelectedCinemas(cinemas.length > 0 ? cinemas : null);
    $[0] = cinemaContext;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const setCinemas = t1;
  let T0;
  let selectedCinemas;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[2] !== cinemaContext.selectedCinemas || $[3] !== className || $[4] !== showFilter) {
    const themeStyles = getThemeStyles(styles);
    let t8;
    if ($[13] !== cinemaContext.selectedCinemas) {
      t8 = cinemaContext.selectedCinemas ?? [];
      $[13] = cinemaContext.selectedCinemas;
      $[14] = t8;
    } else {
      t8 = $[14];
    }
    selectedCinemas = t8;
    if ($[15] !== className || $[16] !== showFilter) {
      t6 = classNames(styles.Collapsible, className, {
        [styles.Open]: showFilter
      });
      $[15] = className;
      $[16] = showFilter;
      $[17] = t6;
    } else {
      t6 = $[17];
    }
    t7 = !showFilter;
    t5 = styles.CollapsibleInner;
    T0 = InlineSelectorWrapper;
    t3 = styles.InlineCinemaFilter;
    t4 = true;
    t2 = classNames(themeStyles);
    $[2] = cinemaContext.selectedCinemas;
    $[3] = className;
    $[4] = showFilter;
    $[5] = T0;
    $[6] = selectedCinemas;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    T0 = $[5];
    selectedCinemas = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
    t7 = $[12];
  }
  let t8;
  if ($[18] !== cinemaContext.availableCinemas || $[19] !== selectedCinemas || $[20] !== setCinemas) {
    t8 = cinemaContext.availableCinemas.length > 1 && <div className={styles.SGroup}><LabelledCheck value={locale.program.allCinemas} className={styles.BaseCheck} selectionCallback={() => setCinemas([])} selected={selectedCinemas.length === 0} hideCheckmark={true} dkVariant="darkOutline" />{cinemaContext.availableCinemas.map(cinema => <LabelledCheck key={cinema.name} value={cinema.name} className={styles.BaseCheck} selectionCallback={isSelected => setCinemas(isSelected ? [...selectedCinemas, cinema.name] : selectedCinemas.filter(c => c !== cinema.name))} selected={selectedCinemas.includes(cinema.name)} hideCheckmark={true} dkVariant="darkOutline" />)}</div>;
    $[18] = cinemaContext.availableCinemas;
    $[19] = selectedCinemas;
    $[20] = setCinemas;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t2 || $[23] !== t8) {
    t9 = <div className={t2}>{t8}</div>;
    $[22] = t2;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== T0 || $[26] !== t3 || $[27] !== t4 || $[28] !== t9) {
    t10 = <T0 className={t3} hideClose={t4}>{t9}</T0>;
    $[25] = T0;
    $[26] = t3;
    $[27] = t4;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== t10 || $[31] !== t5) {
    t11 = <div className={t5}>{t10}</div>;
    $[30] = t10;
    $[31] = t5;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== t11 || $[34] !== t6 || $[35] !== t7) {
    t12 = <div className={t6} inert={t7}>{t11}</div>;
    $[33] = t11;
    $[34] = t6;
    $[35] = t7;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  return t12;
}
//#endregion